import classNames from 'classnames';
import { isFunction, values } from 'lodash/fp';
import PropTypes from 'prop-types';
import * as React from 'react';
import { MouseEventHandler } from 'react';
import Button from '../Button';
import LinkButton from '../LinkButton';
import styles from './style.m.less';

const COLORS = {
    RED: 'RED',
    BLUE: 'BLUE',
    TEAL: 'TEAL',
    YELLOW: 'YELLOW',
};

const getColorClass = (color?: string) => {
    switch (color) {
        case COLORS.RED:
            return styles.red;
        case COLORS.TEAL:
            return styles.teal;
        case COLORS.BLUE:
            return styles.blue;
        case COLORS.YELLOW:
            return styles.yellow;
        default:
            return styles.defaultColor;
    }
};

PillBox.propTypes = {
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.node]).isRequired,
    color: PropTypes.oneOf(values(COLORS)),
    className: PropTypes.string,
    onClick: PropTypes.func,
    href: PropTypes.string,
};

interface Props {
    value: string | number | React.ReactNode;
    color?: keyof typeof COLORS;
    className?: string;
    onClick?: MouseEventHandler;
    href?: string;
}

export default function PillBox({ value, className, onClick, color, href }: Props) {
    const isButton = isFunction(onClick);

    const allClassNames = classNames(
        { [styles.hasOnClick]: isButton || href },
        getColorClass(color),
        styles.container,
        className
    );

    if (isButton) {
        return (
            <Button kind="PLAIN" className={allClassNames} onClick={onClick}>
                {value}
            </Button>
        );
    }
    if (href) {
        return (
            <LinkButton kind="PLAIN" className={allClassNames} href={href} openInNewTab>
                {value}
            </LinkButton>
        );
    }
    return <span className={allClassNames}>{value}</span>;
}
